export const USER_EDIT_ROLE_MODAL_QA_NAME = 'ChangeRole'

export const USER_EDIT_ROLE_FIELD_NAME = 'role'
